
 const formValidation = (form, isEdit, files, setErrors) => {
    let errors = {};
    let isValid = true;

    //    Validate title
    if (!form.title) {
        isValid = false;
        errors.title = 'Constitution Title is required';
    } else if (form.title.length > 100) {
        isValid = false;
        errors.title = 'Constitution Title must be less than 100 characters long';
    }

    // Validate date
    if (!form.date) {
        isValid = false;
        errors.date = 'Date is required';
    }
    // Validate description
    if (!form.description) {
        isValid = false;
        errors.description = 'Description is required';
    }
    // Validate manual file (required for new entries, optional for edits)
    if (!isEdit && !files.manual) {
        isValid = false;
        errors.manual = 'Manual file is required';
    } else if (files.manual) {
        // Validate file type for manual
        const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
        if (!allowedTypes.includes(files.manual.type)) {
            isValid = false;
            errors.manual = 'Manual must be a PDF or Word document';
        }

        // Validate file size (max 10MB)
        const maxSize = 10 * 1024 * 1024; // 10MB
        if (files.manual.size > maxSize) {
            isValid = false;
            errors.manual = 'Manual file size must be less than 10MB';
        }
    }
    // Validate thumbnail file (optional but if provided, validate type and size)
    if (!isEdit && !files.thumbnail) {
        isValid = false;
        errors.thumbnail = 'Thumbnail is required';
    } else if (files.thumbnail) {
        // Validate file type for thumbnail
        const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        if (!allowedImageTypes.includes(files.thumbnail.type)) {
            isValid = false;
            errors.thumbnail = 'Thumbnail must be a JPEG or PNG image';
        }

        // Validate file size (max 5MB)
        const maxImageSize = 5 * 1024 * 1024; // 5MB
        if (files.thumbnail.size > maxImageSize) {
            isValid = false;
            errors.thumbnail = 'Thumbnail file size must be less than 5MB';
        }
    }

    setErrors(errors);
    return isValid;
};

export default formValidation;